import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Utils from 'EurestoFonction/Utils'
import useDebounceSearch from 'EurestoHook/useDebounceSearch'
import useStyledInput from 'EurestoHook/useStyle/Input'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import NumberFormat from 'react-number-format'

const TextMaskCustomPhone = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      format="# ## ## ## ## ##"
    />
  );
}

export default React.memo((props) => {
  const classes = useStyledInput(props)
  const ref = useRef(null)
  const [value, setValue] = useState(props.value && props.value !== 'NULL' ? props.value : '')
  const debounceSearchTerm = useDebounceSearch(value, 300)
  const [element, setElement] = useState(null)
  const id = useMemo(() => props.id || Utils.uuidv4())

  if (props.onChange) {
    useEffect(
      () => {
        // Make sure we have a value (user has entered something in input)
        if (debounceSearchTerm !== undefined) {
          if (debounceSearchTerm !== props.value && element) {
            props.onChange(debounceSearchTerm, props.name, element)
          }
        }
      },
      [debounceSearchTerm]
    )
  }

  const onChange = (e) => {
    setElement(e)
    setValue(e.target.value)
  }

  const textField = _ => {
    return (
      <TextField
        id={id}
        autoComplete={props.autocomplete}
        autoFill={false}
        autoFocus={props.autoFocus}
        className={(props.className || '')}
        value={value}
        onChange={onChange}
        type={props.type || ''}
        max={props.max}
        min={props.min}
        fullWidth
        variant={props.variant || 'outlined'}
        onClick={(e) => {
          props.onClick && props.onClick(e)
        }}
        multiline={props.multi || false}
        rowsMax={props.rowsMax}
        rows={props.rows}
        disabled={props.readOnly}
        inputProps={{
          readOnly: Boolean(props.disabled || false),
          style: {
            overflow: 'auto',
            ...(props.inputStyle || {}),
          },
          ...(props.inputProps || {})
        }}
        InputProps={{
          ...(props.InputProps || {}),
          style: {
            padding: 0,
            marginBottom: 5, ...(props.style || {}), ...(props.InputProps && props.InputProps.style || {})
          },
          ...(props.type === 'phone' && { inputComponent: TextMaskCustomPhone } || {})
        }}
        inputRef={props.inputRef ? props.inputRef : ref}
        placeholder={props.placeholder || ''}
        label={!props.inline && (props.title || props.label)}
        onKeyPress={props.onKeyPress}
        onKeyUp={(e) => {
          props.onKeyUp && props.onKeyUp(e)
        }}
        onKeyDown={(e) => {
          props.onKeyDown && props.onKeyDown(e)
        }}
        classes={classes} />
    )
  }

  return (
    props.inline && <Grid container style={{ margin: 0, padding: 0 }} wrap={'nowrap'}>
      <Grid item style={{ margin: 0, padding: 0, maxWidth: props.inlineWidth || 70, width: props.inlineWidth || 70, color: '#3E3E3E', lineHeight: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre, no-wrap' }}>
        <Grid container style={{ margin: 0, padding: 0, height: '100%', paddingRight: 2.5 }} direction={'column'} justify={'center'}>
          {props.title || props.label}
        </Grid>
      </Grid>
      <Grid item xs style={{ margin: 0, padding: 0, textAlign: 'left' }} className={'Euresto-InputInlineTitle'}>
        {textField(props)}
      </Grid>
    </Grid>
    || textField(props)
  )
})



// WEBPACK FOOTER //
// ./app/Components/Input.js